<template>
  <div v-resize="onResize">
    <chart id="chronology" :chartData="chartData" />
  </div>
</template>
<script>
import Chart from "./Chart.vue";
import axios from "axios";
import moment from "moment";
window.Handbook = window.Handbook || {};
const apiUri = window.Handbook.ApiUri || "https://localhandbookapi.aph.gov.au/";
axios.defaults.baseURL = apiUri;

export default {
  created() {
    this.initialiseMinistries();
  },
  components: {
    Chart,
  },
  mounted() {
    this.onResize();
  },
  props: ["items"],
  methods: {
    onResize() {
      if (window.innerWidth < 769) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    },
    initialiseMinistries() {
      this.loadingMinistries = true;
      const url = `StatisticalInformation/Ministries`;
      axios.get(`api/${url}`).then((response) => {
        this.ministries = response.data;
        this.loadingMinistries = false;
      });
    },
    stringDate(value) {
      if (
        value &&
        value != "undefined" &&
        value != "Undefined" &&
        value != "1900-01-01" &&
        value != "1900-01-01T00:00:00Z" &&
        value != "1900-01-1" &&
        value != "0001-01-01" &&
        value != "0001-01-01T00:00:00Z"
      ) {
        var dateDMY = moment(String(value));
        if (dateDMY.isValid()) {
          return dateDMY.format("DD/MM/YYYY");
        } else {
          var dateFormat = moment(String(value), "YYYY-DD-MM");
          if (dateFormat.isValid()) {
            return dateFormat.format("DD/MM/YYYY");
          } else {
            return "";
          }
        }
      } else {
        return "present";
      }
    },
  },
  data() {
    return {
      isMobile: false,
      ministries: [],
    };
  },
  computed: {
    chartData() {
      var that = this;
      let data = [];
      let sessions = [];
      let prorogations = [];

      const getPrimeMinisterForTimePeriod = (start, end) => {
        const ministries = this.ministries
          .filter(
            (m) =>
              moment(m.DateStart) < moment(end) &&
              moment(m.DateEnd) > moment(start)
          )
          .map((m) => ({
            leaderPHID: m.LeaderPHID,
            ministryName: m.MinistryName,
            dateString:
              this.stringDate(m.DateStart) + "-" + this.stringDate(m.DateEnd),
          }));
        return ministries;
      };

      var min = new Date(1901, 3, 29).valueOf();
      var max = new Date().valueOf();

      this.items.forEach((p) => {
        data.push({
          name: p.Name,
          x: new Date(p.DateElection).valueOf(),
          x2: p.DateDissolution
            ? new Date(p.DateDissolution).valueOf()
            : new Date().valueOf(),
          y: 0,
        });

        p.Sessions.forEach((s, si) => {
          sessions.push({
            name: p.Name + " - Session " + (si + 1),
            x: new Date(s.DateOpening).valueOf(),
            x2: s.DateClosing
              ? new Date(s.DateClosing).valueOf()
              : new Date().valueOf(),
            y: 0,
          });

          s.Prorogations.forEach((pr) => {
            prorogations.push({
              name: p.Name + " - Session " + (si + 1),
              x: new Date(pr.DateProrogued).valueOf(),
              x2: new Date(pr.DateProrogued).valueOf(),
              byGovernorGeneral: pr.ByGovernorGeneral,
              furtherProrogation: pr.FurtherProrogation,
              oneMinuteBefore: pr.OneMinuteBefore,
              reps: pr.Reps,
              senate: pr.Senate
            });
          });
        });
      });

      const plotLines = this.$store.getters.GET_PARLIAMENTS_ORDERED.map(
        (p) => ({
          value: new Date(p.DateElection).valueOf(),
          dashStyle: "shortdash",
          color: "#CCD6EB",
          label: {
            text: p.PID,
          },
        })
      );

      return {
        chart: {
          inverted: true,
          height: 4500
        },
        tooltip: {
          borderWidth: 0,
          backgroundColor: "transparent",
          shadow: false,
          enabled: this.isMobile ? false : true,
          useHTML: true,
          formatter: function () {
            var leaders = getPrimeMinisterForTimePeriod(
              this.point.x,
              this.point.x2
            );
            var todaysDate = new Date();
            var dateIsToday =
              new Date(this.x2).setHours(0, 0, 0, 0) ==
              todaysDate.setHours(0, 0, 0, 0);
            var showEndDate =
              this.series.name === "Prorogations"
                ? ""
                : dateIsToday
                ? "present"
                : new Date(this.x2).toLocaleDateString("en-AU");

            const dateString =
              new Date(this.x).toLocaleDateString("en-AU") +
              (showEndDate ? " - " + showEndDate : "");

            var tooltipMarkup =
              '<div class="tooltip" style="width:300px;min-height: 100px;">' +
              '<div style="vertical-align: top;display:inline-block; width:200px; padding-left:10px;">';

            tooltipMarkup += !that.hoveringLabel
              ? '<p style="font-size:1.1em;font-weight:bold;white-space: normal;">' +
                this.point.name +
                "</p>" +
                '<p style="white-space: normal; margin-bottom:0.2rem;">' +
                dateString +
                "</p>"
              : '<p style="font-size:1.1em;font-weight:bold;margin-top: 35px;white-space: normal;">' +
                this.point.name +
                "</p>";

            if (this.point.options.byGovernorGeneral) {
                tooltipMarkup += '<p>Parliament prorogued by Governor-General<br/> in an address to members of both Houses<br/> in the Senate Chamber.</p>';
            }
            if (this.point.options.furtherProrogation) {
                tooltipMarkup += '<p>Parliament further prorogued</p>';
            }
            if (this.point.options.reps) {
                tooltipMarkup += '<p>House of Representatives</p>';
            }
            if (this.point.senate) {
                tooltipMarkup += '<p>Senate</p>';
            }
            if (this.point.oneMinuteBefore) {
                tooltipMarkup += '<p>Parliament was prorogued one minute<br/> before the House of Representatives<br/> was dissolved.</p>'
            }

            leaders.forEach((leader) => {
              tooltipMarkup +=
                '<div><img style="display:inline-block; height: 50px; border-radius: 5px;" src="https://www.aph.gov.au/api/parliamentarian/' +
                leader.leaderPHID +
                '/image" style="width: 80px;border-radius: 5px;"></img><div style="display:inline-block; padding-left:10px;">' +
                '<span style="font-size:1.1em;font-weight:bold;">' +
                leader.ministryName +
                "</span><br />" +
                "<span>" +
                leader.dateString +
                "</span>" +
                "</div>";
            });

            tooltipMarkup += "</div></div>";

            return tooltipMarkup;
          },
        },

        legend: {
          enabled: false,
        },

        title: {
          text: "Chronology of Parliaments",
        },
        exporting: {
          filename: "Chronology of Parliament over time",
          sourceWidth: 2000,
        },
        xAxis: [
          {
            type: "datetime",
            min: min,
            max: max,
            plotLines,
            reversed: false
          },
          {
            type: "datetime",
            min: min,
            max: max,
            visible: false,
            reversed: false
          },
          {
            type: "datetime",
            min: min,
            max: max,
            visible: false,
            reversed: false
          },          
        ],
        yAxis: [
          {
            title: {
              text: "",
            },
            labels: {
              enabled: this.isMobile ? false : true,
              step: 1,
              style: {
                cursor: "pointer",
              },
            },
            categories: ["Parliaments"],
            // reversed: true,
          },
          {
            title: {
              text: "",
            },
            labels: {
              enabled: this.isMobile ? false : true,
              step: 1,
              style: {
                cursor: "pointer",
              },
            },
            categories: ["Sessions"],
            // reversed: true,
          },          
          {
            title: {
              text: "",
            },
            labels: {
              enabled: this.isMobile ? false : true,
              step: 1,
            },
            categories: ["Prorogations"],
            // offset: 0,
          },
        ],
        series: [
          {
            xAxis: 1,
            yAxis: 1,
            type: "xrange",
            name: "Parliament",
            pointWidth: 30,
            data,
          },
          {
            xAxis: 2,
            yAxis: 2,
            type: "xrange",
            name: "Sessions",
            pointWidth: 30,
            data: sessions,
          },          
          {
            xAxis: 0,
            yAxis: 0,
            type: "timeline",
            name: "Prorogations",
            data: prorogations,
            dataLabels: {
              enabled: false,
            },
          },
        ],
      };
    },
  },
};
</script>